import React, { useEffect, useMemo, useState } from "react";
import { Container, Dropdown, Row, Col } from "react-bootstrap";
import Slider from "@mui/material/Slider";
import { withRouter } from "react-router-dom";
import "./Cards.css";
import { Icon } from "@iconify/react";

const FilterDropDown = (props) => {
  const {
    history,
    priceRangeDropDown,
    onPriceRangeDrop,
    onPriceRangeChange,
    onPriceRangeBoundsChange,
    priceRangeLow,
    priceRangeField,
    clearGenre,
    onPlatformDrop,
    onPlatformChange,
    platformDropDown,
    onLatestDrop,
    onLatestChange,
    latestDropDown,
    onFilterChange,
    genreDropDown,
    onDropDownChange,
    onRegionChange,
    regionFilter,
    lowFilter,
    setLowFilter,
  } = props;


  const isPS = (platformDropDown || "").toLowerCase() === "playstation";

  const LOW_OPTIONS = [
    { label: "All deals", value: "", icon: "mdi:trending-down" },
    { label: "New historical low", value: "new_low", icon: "mdi:arrow-down-bold-circle" },
    { label: "Matches all-time low", value: "matches_low", icon: "mdi:equal-box" },
    { label: "Not an all-time low", value: "not_low", icon: "mdi:minus-circle-outline" },
  ];
  const currentLow = LOW_OPTIONS.find((o) => o.value === (lowFilter || "")) || LOW_OPTIONS[0];

  // ---------- helpers ----------

const Switch2Icon = () => (
  <span
    style={{
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
    }}
  >
    <Icon icon="mdi:nintendo-switch" width="18" />

    <span
      style={{
        position: "absolute",
        right: "-5px",
        top: "-5px",
        fontSize: "9px",
        fontWeight: "bold",
        lineHeight: 1,
      }}
    >
      2
    </span>
  </span>
);

const platformIcon = (platform) => {
  const iconStyle = {
    width: 22,
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
  };

  switch (platform) {
    case "Switch":
      return (
        <span style={iconStyle}>
          <Icon icon="mdi:nintendo-switch" width="18" />
        </span>
      );

    case "Switch 2":
      return (
        <span style={iconStyle}>
          <Switch2Icon />
        </span>
      );

    case "Playstation":
      return (
        <span style={iconStyle}>
          <Icon icon="bi:playstation" width="18" />
        </span>
      );

    default:
      return (
        <span style={iconStyle}>
          <Icon icon="mdi:gamepad-variant" width="18" />
        </span>
      );
  }
};

  const selectPlatform = ({ route, label, value }) => () => {
    if (route) {
      const params = new URLSearchParams(history.location.search);
      params.delete("page");
      const query = params.toString();
      history.push(query ? `${route}?${query}` : route);
    }
    onPlatformChange?.(value);
    onPlatformDrop?.(label);
  };

  const selectLatest = (label) => () => {
    onLatestChange?.(label);
    onLatestDrop?.(label);
  };

  const selectGenre = (label) => () => {
    if (label === "All Genres") {
      clearGenre?.();
    } else {
      onFilterChange?.(label);
    }
    onDropDownChange?.(label);
  };

  const selectPrice = (label) => () => {
    onPriceRangeDrop?.(label);
    onPriceRangeChange?.(label);
  };

  const [priceMenuOpen, setPriceMenuOpen] = useState(false);
  const sliderUpperValue = Number.isFinite(priceRangeField) ? Math.min(priceRangeField, 2501) : 2501;
  const committedSliderValue = [Math.min(priceRangeLow || 0, sliderUpperValue), sliderUpperValue];
  const [draftSliderValue, setDraftSliderValue] = useState(committedSliderValue);
  const [draftMinInput, setDraftMinInput] = useState(String(committedSliderValue[0]));
  const [draftMaxInput, setDraftMaxInput] = useState(
    committedSliderValue[1] === 2501 ? "" : String(committedSliderValue[1])
  );

  useEffect(() => {
    setDraftSliderValue(committedSliderValue);
    setDraftMinInput(String(committedSliderValue[0]));
    setDraftMaxInput(committedSliderValue[1] === 2501 ? "" : String(committedSliderValue[1]));
  }, [priceRangeLow, priceRangeField]);

  const sliderValue = draftSliderValue;
  const commitSliderValue = (nextValue) => {
    const min = Math.max(0, Math.min(nextValue[0], 2500));
    const max = Math.max(min + 1, Math.min(nextValue[1], 2501));
    const committedMax = max === 2501 ? Number.POSITIVE_INFINITY : max;
    setDraftSliderValue([min, max]);
    onPriceRangeBoundsChange?.(min, committedMax);
  };

  const commitInputValues = () => {
    const min = Number(draftMinInput);
    const max = draftMaxInput.trim() === "" ? 2501 : Number(draftMaxInput);

    if (!Number.isFinite(min) || !Number.isFinite(max)) return;

    commitSliderValue([min, max]);
  };
  const sliderLabel = sliderValue[1] === 2501
    ? sliderValue[0] === 0 ? "Any price" : `P${sliderValue[0] + 1}+`
    : sliderValue[0] === 0
    ? `P0-${sliderValue[1].toLocaleString()}`
    : `P${(sliderValue[0] + 1).toLocaleString()}-${sliderValue[1].toLocaleString()}`;

  // ---------- data sources (easy to extend) ----------
  const PLATFORM_OPTIONS = useMemo(
    () => [
      { label: "All Platforms", value: "", route: "/allgames" },
      { label: "Switch", value: "Switch", route: "/switch" },
      { label: "Switch 2", value: "Switch 2", route: "/switch-2" },
      { label: "Playstation", value: "Playstation", route: "/playstation" },
    ],
    []
  );

const LATEST_OPTIONS = useMemo(
  () => ["Popular", "Best Deals", "Top Rated", "New Discounts", "Latest Release", "Price ↑", "Price ↓" ],
  []
);

  const GENRE_OPTIONS = useMemo(
    () => [
      "All Genres",
      "Action",
      "Adventure",
      "Arcade",
      "Fighting",
      "First-Person",
      "Multiplayer",
      "Music",
      "Platformer",
      "Puzzle",
      "Racing",
      "Role-Playing, RPG",
      "Shooter",
      "Simulation",
      "Sports",
      "Strategy",
      "Unique",
    ],
    []
  );

const REGION_LABEL = {
  "": "Any",
  ID: "Indonesia",
  IN: "India",
  TR: "Turkey",
  AR: "Argentina",
  AU: "Australia",
  BR: "Brazil",
  CA: "Canada",
  CH: "Switzerland",
  CO: "Colombia",
  HK: "Hong Kong",
  JP: "Japan",
  MY: "Malaysia",
  MX: "Mexico",
  NO: "Norway",
  NZ: "New Zealand",
  PE: "Peru",
  PL: "Poland",
  SG: "Singapore",
  TH: "Thailand",
  ZA: "South Africa",
  US: "United States",
};

const CHEAPEST_OPTIONS = useMemo(
  () =>
    isPS
      ? ["HK", "ID", "IN", "SG", "TR", "US"]
      : ["AR", "AU", "BR", "CA", "CH", "CO", "HK", "JP", "MX", "MY", "NO", "NZ", "PE", "PL", "SG", "TH", "ZA", "US"],
  [isPS]
);

const sortedCheapestOptions = [...CHEAPEST_OPTIONS].sort((a, b) =>
  (REGION_LABEL[a] ?? a).localeCompare(REGION_LABEL[b] ?? b)
);

const regionState = {
  include: Array.isArray(regionFilter?.include)
    ? regionFilter.include.map((x) => String(x || "").trim().toUpperCase()).filter(Boolean)
    : typeof regionFilter === "string" && regionFilter
    ? [regionFilter.trim().toUpperCase()]
    : [],
  exclude: Array.isArray(regionFilter?.exclude)
    ? regionFilter.exclude.map((x) => String(x || "").trim().toUpperCase()).filter(Boolean)
    : [],
};

const includeSet = new Set(regionState.include);
const excludeSet = new Set(regionState.exclude);

const applyRegionFilter = (include, exclude) => {
  onRegionChange?.({
    include: [...new Set(include)],
    exclude: [...new Set(exclude)].filter((code) => !include.includes(code)),
  });
};

const cycleRegionState = (code) => {
  const included = includeSet.has(code);
  const excluded = excludeSet.has(code);

  if (!included && !excluded) {
    applyRegionFilter([...regionState.include, code], regionState.exclude.filter((x) => x !== code));
    return;
  }

  if (included) {
    applyRegionFilter(regionState.include.filter((x) => x !== code), [...regionState.exclude, code]);
    return;
  }

  applyRegionFilter(regionState.include.filter((x) => x !== code), regionState.exclude.filter((x) => x !== code));
};

const clearRegions = () => applyRegionFilter([], []);

const selectedRegionCount = new Set([
  ...regionState.include,
  ...regionState.exclude,
]).size;

const regionRowClass = (code) => {
  if (includeSet.has(code)) return "is-include";
  if (excludeSet.has(code)) return "is-exclude";
  return "";
};

// "HK" -> "hkregion-logo"
const regionIconClass = (code) =>
  code ? `${String(code).toLowerCase()}region-logo` : "";

const AnyGlyph = () => (
  <span className="region-any-glyph" aria-hidden>
    <Icon icon="mdi:web" width="11" />
  </span>
);

// small globe icon with same box as flags (so it lines up nicely)
const AnyIcon = () => (
  <span
    aria-hidden
    className="me-2 align-middle"
    style={{ display: "inline-block", width: 15, height: 15, lineHeight: "15px", textAlign: "center" }}
  >
    <AnyGlyph />
  </span>
);


  return (
<Container fluid="md">
  <Row className="g-100 justify-content-md-center">
    {/* Platform */}
    <Col xs={2} md={2} className="col-style order-1">
      <Dropdown className="m-1">
<Dropdown.Toggle size="sm" id="dd-platform" className="dropdown-style no-caret w-100" title={platformDropDown}>
  <span className="d-inline-flex align-items-center">
    <span
      className="d-flex align-items-center justify-content-center"
      style={{ width: 22, height: 22 }}
    >
      {platformIcon(platformDropDown)}
    </span>

    <span
      className="d-none"
      title={platformDropDown}
    >
      {platformDropDown}
    </span>
  </span>
</Dropdown.Toggle>
        <Dropdown.Menu className="w-100 dropdown-style" style={{ zIndex: 2000 }}>
          {PLATFORM_OPTIONS.map((opt) => (
<Dropdown.Item as="button" key={opt.label} onClick={selectPlatform(opt)}>
<span className="d-flex align-items-center">
  <span
    className="me-2 d-flex align-items-center justify-content-center"
    style={{ width: 22, height: 22 }}
  >
    {platformIcon(opt.label)}
  </span>

  <span className="d-flex align-items-center">
    {opt.label}
  </span>
</span>
</Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </Col>

    {/* Latest */}
    <Col xs={6} md={6} className="col-style" style={{ order: 0 }}>
      <Dropdown className="m-1">
<Dropdown.Toggle size="sm" id="dd-latest" className="dropdown-style w-100">
  <span
    className="d-inline-block text-truncate align-middle"
    style={{ maxWidth: 'calc(100% - 1.5rem)' }}
    title={latestDropDown}
  >
    {latestDropDown}
  </span>
</Dropdown.Toggle>
        <Dropdown.Menu className="w-100 dropdown-style" style={{ zIndex: 2000 }}>
          {LATEST_OPTIONS.map((label) => (
            <Dropdown.Item as="button" key={label} onClick={selectLatest(label)}>
              {label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </Col>


{/* Cheapest Region */}
<Col xs={2} md={2} className="col-style order-2">
  <Dropdown className="m-1" autoClose="outside">
<Dropdown.Toggle size="sm" id="dd-cheapest" className="dropdown-style no-caret w-100" title="Region">
  <span className="region-toggle-icon-wrap" aria-hidden>
    {regionState.include.length === 1 && !regionState.exclude.length ? (
      <span
        className={`${regionIconClass(regionState.include[0])} align-middle`}
        style={{ display: "inline-block", width: 15, height: 15 }}
      />
    ) : (
      <span className="region-toggle-any-icon">
        <AnyGlyph />
      </span>
    )}

    {selectedRegionCount > 0 && (
      <span className="region-icon-badge">{selectedRegionCount}</span>
    )}
  </span>

<span className="region-filter-text d-none">
  Region
</span>
</Dropdown.Toggle>

    <Dropdown.Menu className="w-100 dropdown-style" style={{ zIndex: 2000 }}>
      <Dropdown.Item as="button" className="region-filter-item" onClick={clearRegions}>
        <span className="d-inline-flex align-items-center">
          <AnyIcon />
          <span className="align-middle">Any</span>
        </span>
      </Dropdown.Item>

      {sortedCheapestOptions.map((code) => (
        <Dropdown.Item
          as="button"
          className={`region-filter-item ${regionRowClass(code)}`}
          key={code}
          onClick={() => cycleRegionState(code)}
        >
          <span className="d-inline-flex align-items-center">
            <span
              className={`${regionIconClass(code)} align-middle me-2`}
              style={{ display: "inline-block", width: 15, height: 15 }}
              aria-hidden
            />
            <span className="align-middle">{REGION_LABEL[code] ?? code}</span>
          </span>
        </Dropdown.Item>
      ))}
    </Dropdown.Menu>
  </Dropdown>
</Col>


    {/* Price */}
    <Col xs={6} md={6} className="col-style order-5">
      <Dropdown
        className="m-1"
        autoClose={false}
        show={priceMenuOpen}
        onToggle={setPriceMenuOpen}
      >
<Dropdown.Toggle size="sm" id="dd-price" className="dropdown-style w-100">
  <span
    className="d-inline-block text-truncate align-middle"
    style={{ maxWidth: 'calc(100% - 1.5rem)' }}
    title={priceRangeDropDown === "All Price Range" ? "Any price" : sliderLabel}
  >
    {priceRangeDropDown === "All Price Range" ? "Any price" : sliderLabel}
  </span>
</Dropdown.Toggle>
        <Dropdown.Menu className="w-100 dropdown-style price-slider-menu" style={{ zIndex: 2000 }}>
          <div className="price-slider-content">
            <div className="price-slider-inputs">
              <label>
                <span>Min</span>
                <input
                  type="number"
                  min="0"
                  max="2500"
                  value={draftMinInput}
                  onChange={(event) => setDraftMinInput(event.target.value)}
                  onBlur={commitInputValues}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") event.currentTarget.blur();
                  }}
                  aria-label="Minimum price"
                />
              </label>
              <label>
                <span>Max</span>
                <input
                  type="number"
                  min="1"
                  max="2501"
                  value={draftMaxInput}
                  placeholder="2.5K+"
                  onChange={(event) => setDraftMaxInput(event.target.value)}
                  onBlur={commitInputValues}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") event.currentTarget.blur();
                  }}
                  aria-label="Maximum price"
                />
              </label>
            </div>
            <Slider
              value={sliderValue}
              min={0}
              max={2501}
              step={1}
              minDistance={1}
              onChange={(_, value) => setDraftSliderValue(value)}
              onChangeCommitted={(_, value) => commitSliderValue(value)}
              valueLabelDisplay="auto"
              valueLabelFormat={(value) => value === 2501 ? "2.5K+" : `P${value.toLocaleString()}`}
              aria-label="Price range"
            />
            <div className="price-slider-scale" aria-hidden="true">
              <span>P0</span>
              <span>P2.5K+</span>
            </div>
            <button
              type="button"
              className="price-slider-reset"
              onClick={selectPrice("All Price Range")}
            >
              <Icon icon="mdi:restart" width="14" aria-hidden="true" />
              <span>Reset price</span>
            </button>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </Col>

    {/* Genre */}
    <Col xs={6} md={6} className="col-style" style={{ order: 4 }}>
      <Dropdown className="m-1">
<Dropdown.Toggle size="sm" id="dd-genre" className="dropdown-style w-100">
  <span
    className="d-inline-block text-truncate align-middle"
    style={{ maxWidth: 'calc(100% - 1.5rem)' }}
    title={genreDropDown}
  >
    {genreDropDown}
  </span>
</Dropdown.Toggle>
        <Dropdown.Menu className="w-100 dropdown-style" style={{ zIndex: 2000 }}>
          {GENRE_OPTIONS.map((label) => (
            <Dropdown.Item as="button" key={label} onClick={selectGenre(label)}>
              {label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </Col>

    {/* All-time low status */}
    {setLowFilter && (
      <Col xs={2} md={2} className="col-style order-3">
        <Dropdown className="m-1">
          <Dropdown.Toggle
            size="sm"
            id="dd-lows"
            className={`dropdown-style no-caret w-100 ${lowFilter ? `low-active low-${lowFilter}` : ""}`}
            title={currentLow.label}
          >
            <Icon icon={currentLow.icon} width="18" aria-hidden="true" />
          </Dropdown.Toggle>
          <Dropdown.Menu align="end" className="dropdown-style" style={{ zIndex: 2000, minWidth: 210 }}>
            {LOW_OPTIONS.map((opt) => (
              <Dropdown.Item
                as="button"
                key={opt.label}
                active={(lowFilter || "") === opt.value}
                onClick={() => setLowFilter(opt.value)}
              >
                <span className="d-inline-flex align-items-center">
                  <Icon icon={opt.icon} width="16" className={`me-2 low-icon-${opt.value}`} aria-hidden="true" />
                  {opt.label}
                </span>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    )}

  </Row>
</Container>

  );
};

export default withRouter(FilterDropDown);
